import { UnstyledButton } from "@mantine/core";
import React from "react";
import { Plus } from "tabler-icons-react";

import styles from "./CreateIssueBtn.module.css";
import { PermissionButton } from "api/permission/buttonpermission";

type CreateIssueBtnProps = {
  onOpenCreateIssueForm: () => void;
};

function CreateIssueBtn({ onOpenCreateIssueForm }: CreateIssueBtnProps) {
  return (
    <PermissionButton
      className={styles.button}
      permission="task_management.create"
      leftIcon={<Plus size={16} />}
      onClick={onOpenCreateIssueForm}
    >
      Add Task
    </PermissionButton>
    // <UnstyledButton className={styles.button} onClick={onOpenCreateIssueForm}>
    //   <span>
    //     <Plus size={16} />
    //   </span>
    //   <span>Add Task</span>
    // </UnstyledButton>
  );
}

export default CreateIssueBtn;
